import { defineComponent as a, openBlock as n, createBlock as r, unref as s, mergeProps as l, withCtx as p, createElementVNode as c } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ a({
  name: "IconGlasses",
  __name: "IconGlasses",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (n(), r(s(m), l(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "M2.25 6.5A3.75 3.75 0 0 1 6 2.75a.75.75 0 0 1 0 1.5A2.25 2.25 0 0 0 3.75 6.5v7.26a4.23 4.23 0 0 1 2.75-1.01 4.25 4.25 0 0 1 3.504 1.844A2.8 2.8 0 0 1 12 13.75a2.8 2.8 0 0 1 1.996.844A4.25 4.25 0 0 1 17.5 12.75a4.23 4.23 0 0 1 2.75 1.01V6.5A2.25 2.25 0 0 0 18 4.25a.75.75 0 0 1 0-1.5 3.75 3.75 0 0 1 3.75 3.75V17a4.25 4.25 0 1 1-8.47-.5h-.003c0-.677-.573-1.25-1.277-1.25s-1.277.573-1.277 1.25H10.72A4.25 4.25 0 1 1 2.25 17V6.5m18 10.5a2.75 2.75 0 1 0-5.5 0 2.75 2.75 0 0 0 5.5 0M6.5 19.75a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
